import { ReactNode } from 'react'
import { PageWrapper } from '@touche-lts/panel-ui/dist'
import { RouteProps, Route, Redirect, RouteComponentProps } from 'react-router'
import { User } from 'services'
import { UserRoleName } from 'models'

export interface PrivateRouteProps extends RouteProps {
  allowedRoles?: UserRoleName[]
}

const PrivateRouteComponent = (props: PrivateRouteProps) => {
  const { component: Component, allowedRoles, ...rest } = props

  const render = (componentProps: RouteComponentProps): ReactNode => {
    if (!User.isAuthenticated) {
      return (
        <Redirect
          to={{
            pathname: '/login',
            state: { from: componentProps.location }
          }}
        />
      )
    }

    if (allowedRoles && !allowedRoles.some(role => User.userRoleNames.includes(role))) {
      return <Redirect to='/stores' />
    }

    return (
      <PageWrapper>
        <Component {...componentProps} />
      </PageWrapper>
    )
  }

  return <Route {...rest} render={render} />
}

const PrivateRoute = PrivateRouteComponent
export { PrivateRoute }
